import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { BrandService } from 'brand';
import { ProductBoxFeatures } from 'prismic';
import { Product } from 'product-shared';
import {
  ProductCardBulletListComponent,
  ProductCardBulletListHeaderComponent,
  ProductCardBulletListItemComponent,
} from 'sakura-ui';

@Component({
  selector: 'lib-product-features',
  imports: [ProductCardBulletListComponent, ProductCardBulletListHeaderComponent, ProductCardBulletListItemComponent],
  templateUrl: './product-features.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBoxFeaturesComponent {
  public product = input<Product>();
  public brand = inject(BrandService).brand;
  public prismicTable = computed<ProductBoxFeatures[]>(() => {
    return this.product()?.prismicTable ?? [];
  });
}
